import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class ProjectObserverService {

  public projectTypeWithParameters: boolean = false;

  private projectTabSource = new Subject<any>();

  public projectTabs$ = this.projectTabSource.asObservable();

  private projectTabs = {
    header: false,
    team: true,
    accounting: false,
    assetmapping: false
  };

  public projectObserve(type: string, formsValid: boolean) {
    this.projectTabs[type] = formsValid;
    this.projectTabSource.next(this.projectTabs);
  }

  public parse(validate: any): boolean {
    let exists = Object.keys(validate).some(function (k) {
      return validate[k] === false;
    });
    if (exists) {
      return false;
    } else {
      return true;
    }
  }
}